import { render } from "./Mb032.vue?vue&type=template&id=4e0421e6"
import script from "./Mb032.vue?vue&type=script&lang=js"
export * from "./Mb032.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__